import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import includes from 'lodash/includes'

import i18n from 'modules/core/lib/i18n'

import type TimeoffPolicy from 'modules/timeoff/store/models/TimeoffPolicy/Policy'

import Item from './_Item'

const BlankSlate = () => {
  return (
    <Box padding="s40" alignItems="center">
      <Text.Normal>
        {i18n.t('time_tracking.settings.overtime.compensation.timeoff.modal.empty')}
      </Text.Normal>
    </Box>
  )
}

interface Props {
  timeoffPolicies: TimeoffPolicy[]
  selectedIds: number[]
  onSelectTimeoffPolicy: (policy: TimeoffPolicy) => () => void
  onSelectMultiple: (selectedIds: number[]) => void
}

export default function List({
  timeoffPolicies,
  selectedIds,
  onSelectMultiple,
  onSelectTimeoffPolicy,
}: Props) {
  if (!timeoffPolicies.length) return <BlankSlate />

  return (
    <>
      {timeoffPolicies.map((policy) => (
        <Item
          key={policy.attributes.id}
          onSelectMultiple={onSelectMultiple}
          onSelectTimeoffPolicy={onSelectTimeoffPolicy}
          selected={includes(selectedIds, policy.attributes.id)}
          timeoffPolicy={policy}
        />
      ))}
    </>
  )
}
